import { useSelector } from "react-redux";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Col } from "antd";
import { DataTableLayout } from "../../../common/components/dataTableLayout/dataTableLayout";
import { usePageFilter } from "../../../hooks/usePageFilters";
import { JobStatusSelector } from "../../v2/job/status/jobStatusSelector";
import { selectUserId } from "../../../redux/slices/userSlice";
import { ServerSideDataGrid } from "../../../common/components/serverSideDataGrid/serverSideDataGrid";
import K from "../../../utilities/constants";
import { Columns } from "../columns";
import { camelToSnakeCase } from "../../../utilities/generalUtility";
import { selectSelectedClientIds } from "../../../redux/slices/globalSelectorSlice";
import { jobToTableRow } from "../../../utilities/mappers/jobs";
import Job from "../../../redux/models/job";

export const JobsContainer = () => {
  const history = useHistory();

  const userId = useSelector(selectUserId);
  const clients = useSelector(selectSelectedClientIds);

  const [search, setSearch] = usePageFilter("jobs_search");
  const [jobStatus, setJobStatus] = usePageFilter("jobs_status");

  const statusId = jobStatus?.value;

  const getServerSideData = useCallback(
    (options) => {
      const body = {
        ...options,
        clientIds: clients,
        filter: { jobStatusId: statusId ?? null },
        search: search || undefined,
        sortBy: options.sortBy ? camelToSnakeCase(options.sortBy) : undefined,
      };

      return getJobs(body);
    },
    [search, statusId, clients],
  );

  const getJobs = async (body) => {
    try {
      const res = await Job.getByClientIdsWithServerSide(body);
      return { data: res.jobs.map(jobToTableRow), total: res.totalCount };
    } catch (error) {
      console.error(error);
    }
  };

  const rowClickedHandler = (event) => {
    const { id, clientsId } = event.data;
    history.push(`/clients/${clientsId}/job/${id}`);
  };

  return (
    <DataTableLayout
      searchDefaultValue={search}
      onSearchChange={setSearch}
      renderFilters={() => (
        <Col style={{ width: 200 }}>
          <JobStatusSelector
            defaultValue={jobStatus}
            onChange={(statusId, status) => setJobStatus(status)}
          />
        </Col>
      )}
    >
      <ServerSideDataGrid
        userId={userId}
        configKey={K.AgGridTable.Keys.GlobalJobsVisibleColumn}
        defaultColumnConfig={Columns}
        getData={getServerSideData}
        rowStyle={{ cursor: "pointer" }}
        onRowClicked={rowClickedHandler}
      />
    </DataTableLayout>
  );
};
